import { CaughtException } from 'src/bff/common'
import { ChannelMenuType } from '../../admin/ChannelConfiguration.communication'
import { TagsStatus } from './channel'

export type TagRequest = {
    channel: string
    entries: OptionsTags
    draftTags?: DraftTags
    ignoreCache?: boolean
}

export type TagResponse = ResponseTags

export type TagMenu = {
    id: string
    name: string
    companyId: string
    type: ChannelMenuType
    error: boolean
    key?: string
    childrenServices?: TagMenuOptionMenus[]
}

export type TagCompany = {
    _id: string
    id: number
    name: string
    error: boolean
}

export type TagSegmentation = {
    name: string
    error: boolean
}

export type TagMedia = {
    name: string
    error: boolean
}

export type TagOrigin = {
    name: string
    error: boolean
}

export type TagMenuOptionMenus = {
    id: string
    description: string
    key?: string
    type: ChannelMenuType
    childrenServices?: TagMenuOptionMenus[]
}

export type TagMenuOption = {
    companyId: string
    companyName: string
    menus: TagMenuOptionMenus[]
}

export type TagCompanyOption = {
    _id: string
    id: number
    name: string
    description?: string
    segmentations: string[]
}

export type TagMediaOption = {
    id: string
    description: string
}

export type TagForwardingOption = {
    name: string
    userId: number
    nomeLogin?: string
    nomeVisualizacao?: string
}

const ADMIN_V2_KEY = 'bff:adminv2'

export const buildAdminV2UsersCompaniesCacheKey = (group: string, channels: string[]) => {
    return `${ADMIN_V2_KEY}:${group}:users:companies:${channels}:users:list}`
}

export type TagOriginOption = {
    id: string
    description: string
}

export type TagForwarding = {
    name: string
    userId: number
    error: boolean
}

export type Tags = {
    identifier: string
    segmentation?: string
    menu?: string[]
    company?: number
    origin?: string
    media?: string
    forwarding?: TagForwarding
}

export type ConfiguredTags = {
    identifier: string
    segmentation?: TagSegmentation
    menu?: TagMenu[]
    company?: TagCompany
    origin?: TagOrigin
    media?: TagMedia
    forwarding?: TagForwarding
}

export type OptionsTags = {
    segmentations: string[]
    menus: TagMenuOption[]
    companies: TagCompanyOption[]
    origins: TagOriginOption[]
    medias: TagMediaOption[]
    forwardings?: TagForwardingOption[]
}

export type ResponseTags = {
    configured: ConfiguredTags[]
    options: OptionsTags
    status: TagsStatus
}

export type SaveTagRequest = {
    channel: string
    tags: Tags
}

export type PublishTagRequest = {
    channel: string
    tags: DraftTags
}

export type SaveTagResponse = { duration: number } & CaughtException

export type DeleteTagRequest = {
    channel: string
    identifier: string
    key?: keyof Tags
    menusId?: string[]
}

export type DeleteTagResponse = { duration: number } & CaughtException

export type DeleteTagRequestFields = Pick<DeleteTagRequest, 'identifier' | 'key' | 'menusId'>

export type DraftTags = { save?: Tags[]; remove?: DeleteTagRequestFields[] }

export type ConfiguredTagsKeys = keyof ConfiguredTags
